'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'citrus-slice';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e2f5';
var svgPathData = 'M480 208c0 150.2-121.8 272-272 272c-59.5 0-114.5-19.1-159.3-51.5l27.4-27.4C115 430.5 163.5 448 216 448c128.1 0 232-103.9 232-232c0-52.5-17.5-101-46.9-139.9l27.4-27.4C460.9 93.5 480 148.5 480 208zM176 412c-28.3-5.7-54.4-17.5-77-33.8l77-77L176 412zm32 3.8l0-122c18.4 4.6 38.2 1.8 54.9-8.4l82.8 82.8C310.7 398 265.5 416 216 416c-2.7 0-5.3-.1-8-.2zm77.8-152.7c10.7-16.5 14-36.5 9.8-55.2l120.3 0c.1 2.7 .2 5.3 .2 8c0 49.5-18 94.7-47.7 129.7l-82.5-82.5zM301.3 176l77-77c16.3 22.6 28 48.7 33.8 77l-110.7 0zm-37.3 37.3c3.7 13.4 .3 28.4-10.3 39s-25.5 14-39 10.3l49.2-49.2zM1.2 430.8C9 438.1 17.3 445 25.8 451.4C76.6 489.5 139.7 512 208 512c167.9 0 304-136.1 304-304c0-68.3-22.5-131.4-60.6-182.2C445 17.3 438.1 9 430.8 1.2L408.2 23.8 23.8 408.2 1.2 430.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCitrusSlice = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;